import { atom } from "jotai";
import { z } from "zod";

const dialogType = [
  "download_app_dialog",
  "support_dialog",
  "status_dialog",
  "coming_soon_dialog",
] as const;

const DialogEnum = z.enum([...dialogType]);
const DialogProps = z.record(z.any());

export const DialogStateSchema = z.object({
  id: DialogEnum,
  props: DialogProps.nullish(),
});

export type DialogState = z.infer<typeof DialogStateSchema>;
export const dialogAtom = atom<DialogState | null>(null);
